import { Center } from '@chakra-ui/react'
import onboardingTable from 'assets/images/svgs/onboarding-table.svg'
import history from "infra/helpers/history";
import CardOnboarding from "../components/card-onboarding";

function TerceiroPasso() {
    return(
        <Center w="100vw" h="100vh">
            <CardOnboarding 
                imageSrc={ onboardingTable }
                headingText="Comunicação"
                subheadText="Tenha contato com moradores e demais administradores em tempo real. Faça comunicados internos de forma fácil e ágil."
                onNext={() => history.push('quarto-passo')}
                onBack={() => history.goBack()}
                onPular={ true }
                step={3}
            />
        </Center>
    )
}

export default TerceiroPasso;